<template>
  <div>
    <div ref="searchWrapper" class="searchWrapper">
      <el-form
        :inline="true"
        size="mini"
        :model="searchForm"
        label-width="100px"
        class="search-wrapper"
        ref="ruleForm"
        :style="{ height: header_H, overflow: 'hidden' }"
      >
        <el-form-item style="float: right; margin-top: -2px">
          <el-button type="text" @click="onCollapse">
            {{ searchCollapse ? '收起' : '展开' }}
            <i :class="[searchCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-right']"></i>
          </el-button>
          <el-button type="primary" @click="criteriaSearch">搜索</el-button>
          <el-button @click="reset" class="orange-btn">重置</el-button>
        </el-form-item>

        <el-form-item label="产品编码:"
          ><el-input v-model.trim="searchForm.filterData.productCode" placeholder="产品编码" style="width: 150px"></el-input
        ></el-form-item>
        <el-form-item label="产品名称:"
          ><el-input v-model.trim="searchForm.filterData.productName" placeholder="产品名称" style="width: 150px"></el-input
        ></el-form-item>
        <el-form-item label="产品生命周期:">
          <el-select v-model="searchForm.filterData.proStateList" multiple collapse-tags placeholder="全部">
            <el-option v-for="item in proStateList" :label="item.label" :key="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品定位:">
          <el-select v-model="searchForm.filterData.productPositioning" filterable placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in positioningList" :label="item.val" :key="item.key" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="大型号:"
          ><el-input v-model.trim="searchForm.filterData.bigModel" placeholder="大型号" style="width: 150px"></el-input
        ></el-form-item>
        <template v-if="searchCollapse">
          <el-form-item label="产品供应商:">
            <el-select v-model="searchForm.filterData.supplier" placeholder="全部">
              <el-option v-for="item in supplierOptions" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="型号:">
            <el-input v-model.trim="searchForm.filterData.model" placeholder="型号"></el-input>
          </el-form-item>
          <el-form-item label="是否新品:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.newPro" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="是" value="Y" />
              <el-option label="否" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item label="品类:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.variety" filterable placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in varietyList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="风格:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.style" filterable placeholder="全部">
              <el-option v-for="item in styleList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否下架:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.shelfRemoveFlag" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="是" value="是" />
              <el-option label="否" value="否" />
            </el-select>
          </el-form-item>
          <el-form-item label="使用对象:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.useObject" placeholder="全部">
              <el-option v-for="item in useObjectList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类细分:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.category" filterable placeholder="全部">
              <el-option v-for="item in categoryList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="功能:" v-show="searchCollapse">
            <el-input v-model.trim="searchForm.filterData.functionality" placeholder="功能" style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="空间:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.space" filterable placeholder="全部">
              <el-option v-for="item in spaceList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品主材质:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.material" filterable placeholder="全部">
              <el-option v-for="(item, index) in materialList" :label="item.optionValue" :key="index" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="系列:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.series" filterable placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in seriesOptions" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.imgExist" placeholder="全部" style="width: 150px">
              <el-option label="全部" value="" />
              <el-option label="有" value="true" />
              <el-option label="无" value="false" />
            </el-select>
          </el-form-item>
          <span class="form-number-input">
            <el-form-item label="尺寸:" v-show="searchCollapse">
              <el-input-number
                v-model="searchForm.filterData.productSizeMin"
                @change="lengthHandleChange"
                :controls="false"
                :min="0"
                placeholder="min"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="-" class="date-number-middle" v-show="searchCollapse">
              <el-input-number
                v-model="searchForm.filterData.productSizeMax"
                @change="lengthHandleChange"
                :controls="false"
                :min="searchForm.filterData.productSizeMin"
                placeholder="max"
              ></el-input-number>
            </el-form-item>
          </span>
          <el-form-item label="所属板块:" v-show="searchCollapse">
            <el-select v-model="searchForm.filterData.plate" filterable placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in plateOptions" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <span class="form-date-picker">
            <el-form-item label="上市时间:" v-show="searchCollapse">
              <el-date-picker
                v-model="searchForm.filterData.marketOnBegin"
                :picker-options="beginDate(searchForm.filterData.marketOnEnd)"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle" v-show="searchCollapse">
              <el-date-picker
                v-model="searchForm.filterData.marketOnEnd"
                :picker-options="processDate(searchForm.filterData.marketOnBegin)"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </span>
          <el-form-item label="所属类型:" prop="">
            <el-select v-model="searchForm.filterData.type">
              <el-option label="全部" value="" />
              <el-option v-for="item in types" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属店铺:" prop="">
            <el-select v-model="searchForm.filterData.shopName" filterable>
              <el-option label="全部" value="" />
              <el-option v-for="(item, index) in shopOptions" :key="index" :label="item.shopName" :value="item.shopName"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否含松木:" prop="">
            <el-select v-model="searchForm.filterData.containsPine">
              <el-option label="全部" value="" />
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适配床垫:" prop="">
            <el-input v-model.trim="searchForm.filterData.adapterMattress" placeholder="适配床垫" style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="标签:">
            <el-input v-model.trim="searchForm.filterData.productLabel" placeholder="标签" />
          </el-form-item>
          <el-form-item label="尺寸区间:">
            <el-select v-model="searchForm.filterData.productSizeInterval" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="(item, index) in sizeIntervalList" :label="item" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品规格:">
            <el-input v-model.trim="searchForm.filterData.specDesc" placeholder="产品规格" />
          </el-form-item>
          <el-form-item label="填充物:">
            <el-select v-model="searchForm.filterData.filler" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in fillerList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="饰面工艺:">
            <el-select v-model="searchForm.filterData.finishingProcess" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in finishingProcessList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类型:">
            <el-select v-model="searchForm.filterData.productType" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in productTypeList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="台面材质:">
            <el-select v-model="searchForm.filterData.tableMaterial" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in tableMaterialList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="脚类型:">
            <el-select v-model="searchForm.filterData.footType" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in footTypeList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="拉手类型:">
            <el-select v-model="searchForm.filterData.handleType" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in handleTypeList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <el-container class="list-wrapper">
      <el-header height="auto" style="margin-top: 10px; padding: 0 10px; text-align: right">
        <el-button type="primary" @click="exportExcel" size="mini"> 导出 </el-button>
        <el-button type="primary" @click="downloadImg" size="mini"> 下载图片 </el-button>
        <el-button
          class="orange-btn"
          size="mini"
          @click="onComparison"
          v-permission="`ec-pc-new$goodsManage$basicInformationManagement$productList$ProductComparison`"
          >产品对比</el-button
        >
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
      </el-header>

      <el-main class="table-wrap" style="line-height: 20px">
        <el-table
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData.records"
          :height="tableHeight"
          @selection-change="onSelectChange"
          style="width: 100%"
          border
          v-if="tableReload"
        >
          <el-table-column type="selection" width="40" fixed="left"> </el-table-column>
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            :fixed="item.fixed"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
          >
            <template  #header v-if="item.prop === 'lifeCycle'">
              <span>{{ item.label }}</span>
              <el-tooltip content="小件代发产品的生产周期" placement="top">
                <i class="el-icon-question tip-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <template v-if="item.label === '图片'">
                <el-button v-if="scope.row.imgUrlList.length" size="mini" type="text" @click="viewImg(scope.row.imgUrlList)">查看</el-button>
              </template>
              <template v-else-if="item.label === '产品背部图'">
                <el-button v-if="scope.row.backGroupImgUrlList.length" size="mini" type="text" @click="viewImg(scope.row.backGroupImgUrlList)">查看</el-button>
              </template>
              <template v-else-if="item.label === '产品底部图'">
                <el-button v-if="scope.row. bottomImgUrlList.length" size="mini" type="text" @click="viewImg(scope.row. bottomImgUrlList)">查看</el-button>
              </template>
              <template v-else-if="item.label === '三维图'">
                <el-button v-if="scope.row.solidPhotoList.length" size="mini" type="text" @click="showSolidPhoto(scope.row.solidPhotoList)">查看</el-button>
              </template>
              <template v-else-if="item.label === '工程图'">
                <el-button v-if="scope.row.engineeringPhotoUrl" size="mini" type="text" @click="showEngineeringImg(scope.row.engineeringPhotoUrl)">查看</el-button>
              </template>
              <template v-else-if="item.label === 'DDM产品信息'">
                <el-button size="mini" type="text" @click="goDetails(scope.row)">查看</el-button>
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer style="text-align: right; padding-bottom: 10px" height="auto">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>

    <!--下载图片-->
    <el-dialog title="下载图片" :visible.sync="downloadVisible" :close-on-click-modal="false" @close="downloadClose">
      <div>
        <el-form :inline="true" size="mini" :model="downloadForm" label-width="80px" ref="downloadForm">
          <el-form-item style="float: right; margin-top: -2px">
            <el-button type="primary" @click="dialogSearch">搜索</el-button>
            <el-button @click="dialogReset" class="orange-btn">重置</el-button>
          </el-form-item>
          <el-form-item label="产品编码:"
            ><el-input v-model="downloadForm.filterData.productCode" placeholder="产品编码" style="width: 150px"></el-input
          ></el-form-item>
          <el-form-item label="产品名称:"
            ><el-input v-model.trim="downloadForm.filterData.productName" placeholder="产品名称" style="width: 150px"></el-input
          ></el-form-item>
        </el-form>
        <div style="margin-bottom: 18px">
          <span>{{ picturesText.foundCount }}成功，{{ picturesText.lostCount }}失败</span>
          <el-tooltip class="item" effect="dark" placement="top" :disabled="!picturesText.tips.length" :open-delay="500">
            <span class="el-icon-warning-outline"></span>
            <div style="width: 220px" slot="content">
              {{ picturesText.tips }}
            </div>
          </el-tooltip>
          <el-input size="mini" v-model="picturesText.tips" style="width: 320px">
            <i slot="suffix" class="el-icon-document-copy" v-clipboard:copy="picturesText.tips" v-clipboard:success="clipboardSuccessHandler"></i>
          </el-input>
        </div>
        <el-row>
          <el-col :span="12">
            <el-table
              ref="table"
              v-loading="loadingDialog"
              element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionChange"
              :row-key="
                (row) => {
                  return row.productCode;
                }
              "
              :header-cell-style="{ backgroundColor: '#F4F8FB' }"
              :data="downloadTableData.records"
              :height="300"
              style="width: 100%"
              border
            >
              <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
              <el-table-column label="图片" show-overflow-tooltip width="60">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.imgUrl" size="mini" type="text" @click="showImg(scope.row.imgUrl)">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column label="产品编码" prop="productCode" show-overflow-tooltip width="120"></el-table-column>
              <el-table-column label="产品名称" prop="productName" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="text-align: right; padding-top: 10px" height="auto">
              <el-pagination
                @current-change="downloadHandleCurrentChange"
                :current-page="downloadTableData.pageNum"
                :page-sizes="[30, 100, 500, 1000]"
                :page-size="downloadTableData.pageSize"
                layout="total, prev, pager, next"
                :total="downloadTableData.total"
              ></el-pagination>
            </div>
          </el-col>
          <el-col :span="12" style="padding-left: 30px">
            <el-table
              element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading"
              :header-cell-style="{ backgroundColor: '#F4F8FB' }"
              :data="selectSpus"
              :height="300"
              style="width: 100%"
              border
            >
              <el-table-column label="图片" show-overflow-tooltip width="60">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.imgUrl" size="mini" type="text" @click="showImg(scope.row.imgUrl)">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column label="产品编码" prop="productCode" show-overflow-tooltip width="120"></el-table-column>
              <el-table-column label="产品名称" prop="productName" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-footer style="text-align: center; padding-top: 30px">
          <el-button size="small" @click="downloadVisible = false">取 消</el-button>
          <el-button style="margin-left: 10px" size="small" type="primary" @click="download">下载</el-button>
        </el-footer>
      </div>
    </el-dialog>

    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>

    <!-- 产品尺寸编辑 -->
    <modify-size v-model="sizeVisible" :rowData="rowData" v-if="sizeVisible"></modify-size>

    <!-- 自定义列 -->
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>

    <!-- DOM产品信息 -->
    <productDetails :visible.sync="isShowDetails" v-if="isShowDetails" :rowData="rowData" />

    <!-- 产品对比 -->
    <productOmparison :visible.sync="isShowOmparison" v-if="isShowOmparison" :selection="selection" />
  </div>
</template>

<script>
import imgShow from '@/views/components/imgShow';
import imgUpload from '@/views/components/imgUpload';
import modifySize from './Product-list-midify-size';
import productDetails from './product-details.vue';
import productOmparison from './product-omparison.vue';
import customPropsMixin from './customProps.mixin';
import moment from 'moment';
import axios from '@/utils/axiosInstance';
import pagePathMixin from '@/utils/page-path-mixin'
import { FILE_TYPE } from '@/utils/Global';

export default {
  components: { imgShow, imgUpload, modifySize, productDetails, productOmparison },
  name: 'productList',
  mixins: [customPropsMixin, pagePathMixin],
  data() {
    const proStates = [
      { label: '全部', value: '' },
      { label: '在产', value: 'E' },
      { label: '未投产', value: 'A' },
      { label: '退市', value: 'B' },
      { label: '预退市', value: 'C' },
      { label: '停销', value: 'D' },
    ];
    return {
      header_H: '38px',
      proStateList: [],
      varietyList: [],
      styleList: [],
      spaceList: [],
      materialList: [],
      useObjectList: [],
      categoryList: [],
      supplierOptions: [],
      mattressType: [],
      overallStyle: [],
      plateOptions: [],
      seriesOptions: [],
      sizeIntervalList: [],
      fillerList: [],
      finishingProcessList: [],
      productTypeList: [],
      tableMaterialList: [],
      footTypeList: [],
      handleTypeList: [],
      selection: [],
      searchCollapse: false,
      loading: false,
      loadingDialog: false,
      loadingExport: false,
      isShowDetails: false,
      isShowOmparison: false,
      imgUrl: '',
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchForm: {
        filterData: {
          proStateList: ['E', 'F', 'G'],
          supplier: '全部',
          clearance: '',
          newPro: '',
          variety: '',
          style: '全部',
          useObject: '全部',
          category: '全部',
          space: '全部',
          material: '全部',
          series: '',
          plate: '全部',
          imgExist: '',
          type: '',
          shopName: '',
          newPushTimes: '',
          containsPine: '',
          columnsData: [],
          shelfRemoveFlag: '',
          productSizeInterval: '',
          specDesc: '',
          filler: '',
          finishingProcess: '',
          productType: '',
          tableMaterial: '',
          footType: '',
          handleType: '',
          mattressType: '',
        },
      },
      downloadForm: {
        filterData: {},
      },
      downloadTableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      addData: {},
      editData: {},
      editFormVisible: false,
      // 图片弹窗
      imgFormVisible: false,
      imgList: [],
      upType: 0,
      currentRow: [],
      imgListProp: [],
      tableReload: true,
      // 尺寸编辑弹窗
      sizeVisible: false,
      rowData: {},
      types: [],
      shopOptions: [],
      positioningList: [],
      downloadVisible: false,
      picturesText: {
        foundCount: 0,
        lostCount: 0,
        tips: '',
      },
      selectSpus: [],
      statusList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {
    windowWidth() {
      return document.body.clientWidth;
    },
    tableHeight() {
      if (!this.searchCollapse) {
        return window.innerHeight - 222;
      } else {
        let formHeight = (this.$refs['searchWrapper'] && this.$refs['searchWrapper'].offsetHeight) || 0;
        return window.innerHeight - (this.windowWidth == 1366 ? 0 : formHeight) - 222 + 46;
      }
    },
  },
  watch: {
    $route: {
      handler(val, olv) {
        var query = val.query ? val.query : {};
        if (
          olv.path == '/dataBoard/newProductStatistics' &&
          (query.marketOnBegin != this.searchForm.filterData.marketOnBegin ||
          query.marketOnEnd != this.searchForm.filterData.marketOnEnd) &&
          JSON.stringify(val.query) != '{}'
        ) {
          this.searchForm.filterData.marketOnBegin = query.marketOnBegin;
          this.searchForm.filterData.marketOnEnd = query.marketOnEnd;
          this.onSearch();
        }
      },
    },
  },
  methods: {
    lengthHandleChange(value) {
      if (this.searchForm.filterData.lengthMin && this.searchForm.filterData.lengthMax) {
        if (this.searchForm.filterData.lengthMin > this.searchForm.filterData.lengthMax) {
          this.searchForm.filterData.lengthMax = this.searchForm.filterData.lengthMin;
        }
      }
    },
    clipboardSuccessHandler() {
      this.$message.success('已复制');
    },
    onSearch() {
      this.searchForm.pageNum = this.tableData.pageNum;
      this.searchForm.pageSize = this.tableData.pageSize;
      this.searchForm.exportTag = false;
      this.loading = true;
      this.$q.product.baseList({ data: JSON.stringify(this.searchForm) }).then((res) => {
        this.tableData = this.dataFormat(res.data);
        this.loading = false;
      });
    },
    criteriaSearch() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.onSearch();
    },

    handleSizeChange(val) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = val;
      this.onSearch();
    },
    downloadHandleCurrentChange(val) {
      this.downloadTableData.pageNum = val;
      this.pictureList();
      if (this.statusList.length) {
        this.statusList.forEach((row) => {
          if (
            this.downloadTableData.records.find((item) => {
              return row.productCode == item.productCode;
            })
          ) {
            this.$refs.table.toggleRowSelection(
              this.downloadTableData.records.find((item) => {
                return row.productCode == item.productCode;
              }),
              true
            );
          } else {
            this.$refs.table.toggleRowSelection(row, true);
          }
        });
      }
    },
    editClose() {
      this.$refs.upload.clearFiles(); // 清空
    },
    // 查看图片
    viewImg(imgUrlList) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = imgUrlList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
      console.log(this.imgList);
    },
    // 查看工程图片
    showSolidPhoto(imgList) {
      const imgPth = imgList[0].path
      const type = 'pdf'
      if(imgPth.toLowerCase().includes(type.toLowerCase())) {
        window.open(imgPth)
      }else {
        this.imgFormVisible = true;
        this.imgList = [imgPth];
      }
      
    },
    // 查看工程图片
    showEngineeringImg(img) {
      this.imgFormVisible = true;
      this.imgList = [img];
    },

    showImg(imgUrlList) {
      this.imgFormVisible = true;
      this.imgList = [];
      this.imgList.push(imgUrlList);
    },
    goDetails(row) {
      this.isShowDetails = true;
      this.rowData = { ...row };
    },
    onSelectChange(selection = []) {
      this.selection = selection;
    },
    onComparison() {
      if (!this.selection.length) {
        this.$message.error('请选择至少一条数据');
        return;
      }
      this.isShowOmparison = true;
    },
    dialogSearch(type) {
      this.loadingDialog = true;
      this.$q.product
        .pictureSearch({
          data: this.downloadForm.filterData,
        })
        .then((res) => {
          if (res.code == 200) {
            this.picturesText = {
              foundCount: res.data.foundCount || 0,
              lostCount: res.data.lostCount || 0,
              tips: res.data.errCodes || '',
            };
            this.statusList = res.data.list;
            if (res.data.list.length) {
              res.data.list.forEach((row) => {
                if (
                  this.downloadTableData.records.find((item) => {
                    return row.productCode == item.productCode;
                  })
                ) {
                  this.$refs.table.toggleRowSelection(
                    this.downloadTableData.records.find((item) => {
                      return row.productCode == item.productCode;
                    }),
                    true
                  );
                } else {
                  this.$refs.table.toggleRowSelection(row, true);
                }
              });
            }
          }
          this.loadingDialog = false;
        })
        .catch((_) => {
          this.loadingDialog = false;
        });
    },

    pictureList() {
      this.loadingDialog = true;
      let data = {
        filterData: this.downloadForm.filterData,
        pageNum: this.downloadTableData.pageNum,
        pageSize: this.downloadTableData.pageSize,
      };
      this.$q.product
        .pictureList({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.downloadTableData = res.data;
          } else {
            this.downloadTableData.records = [];
          }
          this.loadingDialog = false;
        })
        .catch((_) => {
          this.loadingDialog = false;
        });
    },

    dialogReset() {
      this.downloadForm.filterData = {};
      this.$refs.table.clearSelection();
      this.downloadTableData.pageNum = 1;
      this.pictureList();
      this.picturesText.foundCount = 0;
      this.picturesText.lostCount = 0;
      this.picturesText.tips = '';
    },
    downloadClose() {
      this.$refs.table.clearSelection();
      this.downloadForm.filterData = {};
      this.picturesText.foundCount = 0;
      this.picturesText.lostCount = 0;
      this.picturesText.tips = '';
    },

    handleSelectionChange(val) {
      console.log('val', val);
      this.selectSpus = this.removal(val);
    },

    removal(arrObj) {
      //去重
      let map = new Map();
      for (let item of arrObj) {
        if (!map.has(item.productCode)) {
          map.set(item.productCode, item);
        }
      }
      return [...map.values()];
    },

    //下载图片
    downloadImg() {
      this.downloadVisible = true;
      this.pictureList();
    },

    download() {
      if (!this.selectSpus.length) {
        this.$message.error('下载数据不能为空');
        return;
      }
      let _this = this;
      this.downloadVisible = false;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.$q.product.pictureDownload({ data: { list: this.selectSpus } }).then((res) => {
        if (res.message) {
          var timer = setInterval(() => {
            _this.$q.goodsAnalysis
              .filePath({ fragment: [res.message] })
              .then((res) => {
                if (res.message) {
                  loading.close();
                  clearInterval(timer);
                  console.log(888);
                  _this.downLoadLink(res.message, `产品搜索${moment().format('YYYYMMDDHHmmss')}.xlsx`);
                }
              })
              .catch((err) => {
                //this.$message(err.message)
              });
          }, 3000);
        }
      });
      // setTimeout(() => {
      //   loading.close();
      // }, 2000);
    },

    downLoadLink(filePath, fileName) {
      console.log(999);
      var xhr = new XMLHttpRequest();
      xhr.open('GET', filePath, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement('a');
            var body = document.querySelector('body');

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = 'none';
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        taskDTO: {
          appCode: 'ec-pc-new',
          // 数据过滤
          paramMap: {
            exportTag: true,
            ...this.searchForm.filterData,
          },
          reportName: 'productExport',
        },
        // 配置导出列
        columnDTOs: [
          // {
          //   columnName: '包件编码',
          //   parentColumnName: null,
          //   fieldName: 'packCode',
          //   fieldType: 'string',
          //   columnFormat: null
          // }
        ],
      };
      let labels = this.columnData.map((v) => v.label);
      let props = this.columnData.map((v) => v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: 'string',
          columnFormat: null,
        });
      });
      // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== '图片');
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        console.log(res);
        loading.close();
        this.$message({
          type: 'success',
          message: '导出成功,请在导出列表中查看',
        });
      });
    },

    // 图片导入
    importImg() {
      // 核心语句
      this.openSubPage({
        path: '/ImportImgProduct',
        name: 'ImportImgProduct', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          fileType: FILE_TYPE.产品图片,
        },
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    reset() {
      this.searchForm.filterData = {
        proStateList: ['E', 'F', 'G'],
        supplier: '全部',
        clearance: '',
        newPro: '',
        variety: '',
        style: '全部',
        useObject: '全部',
        category: '全部',
        space: '全部',
        material: '全部',
        series: '',
        plate: '全部',
        imgExist: '',
        type: '',
        shopName: '',
        newPushTimes: '',
        shelfRemoveFlag: '',
        productSizeInterval: '',
        specDesc: '',
        filler: '',
        finishingProcess: '',
        productType: '',
        tableMaterial: '',
        footType: '',
        handleType: '',
        mattressType: '',
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    clearImg() {
      this.imgUrl = null;
    },
    dataFormat(data) {
      let list = data.records;
      for (let item of list) {
        item.clearance ? (item.clearance = '是') : (item.clearance = '否');
      }
      data.records = list;
      return data;
    },
    beginDate(date) {
      return {
        disabledDate(time) {
          time.setHours(-8);
          // 如果结束时间不为空，则小于结束时间
          if (date) {
            return new Date(date).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    processDate(date) {
      return {
        disabledDate(time) {
          time.setHours(8);
          // 如果开始时间不为空，则结束时间大于开始时间
          if (date) {
            return new Date(date).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    getOptionTypes() {
      this.$q.product.optionTypes().then((res) => {
        console.log('res', res);
        this.shopOptions = res.data.belongsToStore;
        this.varietyList = res.data.varietyList;
        this.styleList = [{ optionValue: '全部' }, ...res.data.styleList];
        this.spaceList = [{ optionValue: '全部' }, ...res.data.spaceList];
        this.materialList = [{ optionValue: '全部' }, ...res.data.materialList];
        this.useObjectList = [{ optionValue: '全部' }, ...res.data.useObjectList];
        this.categoryList = [{ optionValue: '全部' }, ...res.data.categoryList];
        this.overallStyle = res.data.overallStyleList;
        this.mattressType = res.data.mattressTypeList;
        this.sizeIntervalList = res.data.sizeIntervalList;
        this.fillerList = res.data.fillerList;
        this.finishingProcessList = res.data.finishingProcessList;
        this.productTypeList = res.data.productTypeList;
        this.tableMaterialList = res.data.tableMaterialList;
        this.footTypeList = res.data.footTypeList;
        this.handleTypeList = res.data.handleTypeList;
      });
    },
    get_getProductSupplierSelect() {
      this.$q.product.getProductSupplierSelect().then((res) => {
        this.supplierOptions = [{ optionValue: '全部' }, ...res.data.slice(1)];
      });
    },
    get_plateSelect() {
      this.$q.product.plateSelect().then((res) => {
        this.plateOptions = res.data;
      });
    },
    get_seriesSelect() {
      this.$q.product.seriesSelect().then((res) => {
        this.seriesOptions = res.data;
      });
    },
    onCollapse() {
      this.searchCollapse = !this.searchCollapse;
      this.tableReload = false;
      this.$nextTick((_) => {
        this.tableReload = true;
      });
      if (this.searchCollapse) {
        this.header_H = 'auto';
      } else {
        this.header_H = '38px';
      }
    },
    // 编辑尺寸
    editSize(row) {
      this.rowData = row;
      this.sizeVisible = true;
    },
    // 所属店铺
    get_shopOptions() {
      this.$q.product.storeSelect().then((res) => {
        // this.shopOptions = res.data;
      });
    },
    // 产品定位下拉
    queryMarketingPositioning() {
      this.$q.newProduct.queryMarketingPositioning().then((res) => {
        this.positioningList = res.data;
      });
    },
    // 所属类型
    get_types() {
      this.$q.product.getType().then((res) => {
        this.types = res.data;
      });
    },
    //产品生命周期
    commonProductStateList() {
      let data = { ...this.currencyForm };
      data.reportCode = 'commonProductStateList';
      axios.post(`/ec-pc-api/custom/reports/data/commonProductStateList`, data).then((res) => {
        if (res.code == 200) {
          this.proStateList = res.data.list.map((v) => {
            return {
              ...v,
              value: v.proState,
              label: v.proStateDesc,
            };
          });
        }
      });
    },
  },

  mounted() {
    let query = this.$route.query;
    if (query.marketOnBegin && query.marketOnEnd) {
      this.searchForm.filterData.marketOnBegin = query.marketOnBegin;
      this.searchForm.filterData.marketOnEnd = query.marketOnEnd;
    }
    console.log(this.windowWidth);
    this.getOptionTypes();
    this.get_getProductSupplierSelect();
    this.get_plateSelect();
    this.get_seriesSelect();
    this.get_shopOptions();
    this.queryMarketingPositioning();
    this.get_types();
    this.commonProductStateList();
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.inline-block {
  display: inline-block;
}

.search-wrapper {
  margin: 5px;
  border-radius: 5px
  padding: 8px 0 0 8px;
  padding-bottom: 0px;
  background-color: #ffffff;

  >>> .el-form-item {
    margin-bottom: 10px;
  }

  >>> .el-divider {
    margin: 10px 0;
  }
}



.list-wrapper {
  margin: 5px;
  border-radius: 5px
  background-color: #ffffff;
}

.table-wrap {
  padding: 10px;
}

.info-form >>> .el-form-item label:after {
  content: '';
  display: inline-block;
  width: 100%;
}

.info-form >>> .el-form-item__label {
  text-align: justify;
}

.el-icon-document-copy {
  color: #3cc5a5;
  font-size: 16px;
  cursor: pointer;
}

.el-icon-warning-outline {
  cursor: pointer;
}

>>>.el-input__suffix {
  line-height: 32px;
}
</style>
